export default {"src":"/_next/static/media/CHAMPIONS.3bee5270.svg","height":53,"width":267};